module.exports = __webpack_public_path__ + "media/images/home/demo-2a15854ddc0dcd55c0dfd582e7c6a5fe.png";